import API from '@services/API';

const CaixaService = {

	listar: async (processo) => await API.list(`${processo}/caixas/listar`),
  	filtrar: async (processo, filtros) => await API.filters(`${processo}/caixas`, filtros),
	buscarPorId: async (processo,id) => await API.list(`${processo}/caixas/${id}`),
	getEscolas: async (processo,id) => await API.list(`${processo}/caixas/${id}/escolas`),
	desassociarEscola: async (processo,id,idEnvelope) => await API.put(`${processo}/caixas/${id}/escolas/${idEnvelope}/desassociar`),
	atualizarStatus: async (processo, id, status) => await API.put(`${processo}/caixas/${id}/status/${status}`),
  armazenarCaixa: async (obj) => await API.put(`${obj.processoId}/caixas/${obj.caixaId}/registrarArmazenamento`, obj),

	adicionar: async (processo, form) => await API.add(`${processo}/caixas`, form),

 	editar: async (processo, id, envelope) => await API.edit(`${processo}/caixas`, id, envelope),

  	excluir: async (processo, id) => await API.remove(`${processo}/caixas`, id),
	listarStatus: async () => await API.list(`caixas/status`),
	imprimirEtiqueta: async (processo, codigoInep) => await API.download(`${processo}/caixas/${codigoInep}/etiqueta`),
	semCaixa: async(processo) => await API.list(`/${processo}/escolas/cartoes/origem/impa/semCaixa`),

	removerEnvelopeDaCaixa: async (processo, caixaId, id) => await API.remove(`${processo}/caixas/${caixaId}/envelope`, id),
	triarCaixa: async (processo, id) => await API.put(`${processo}/caixas/${id}/triar`),

}

export default CaixaService;
